/*
 * Keeps the cart drawer honest after the Back / Forward buttons.
 *
 * The theme's AppContext (compiled into scripts.js) takes the cart from the
 * page HTML (`initial-cart`, rendered by Liquid) and only asks Shopify for it
 * again after an add, a quantity change or a removal. When a visitor goes
 * Back, the browser shows its saved copy of the earlier page, cart and all, so
 * a cart that was empty when that page was first loaded is shown as empty
 * again - even though the real cart still holds everything. The next add then
 * fetches /cart.js and every item "reappears". Customers saw this in Clarity.
 *
 * So whenever a page is shown from history, the cart that page is displaying
 * is compared with the real one, and the page is reloaded if they differ.
 * "Displaying" starts as the Liquid snapshot below, and follows every /cart.js
 * response the theme itself reads, because that is exactly what it renders.
 */
(function () {
    var script = document.currentScript;
    if (!script || !window.fetch) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var displayed = script.dataset.pageCart || '';
    var originalFetch = window.fetch;

    function signature(cart) {
        return (cart.items || []).map(function (item) {
            return item.key + ':' + item.quantity + ';';
        }).join('');
    }

    window.fetch = function (input) {
        var request = originalFetch.apply(this, arguments);
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\.js(\?|$)/.test(url)) {
            request.then(function (response) {
                if (!response.ok) return;
                response.clone().json().then(function (cart) {
                    displayed = signature(cart);
                }).catch(function () {});
            }).catch(function () {});
        }
        return request;
    };

    window.addEventListener('pageshow', function (event) {
        var navigation = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        var fromHistory = event.persisted || (navigation && navigation.type === 'back_forward');
        if (!fromHistory) return;

        originalFetch(root + 'cart.js', {cache: 'no-store', credentials: 'same-origin'})
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (cart) {
                if (cart && signature(cart) !== displayed) window.location.reload();
            })
            .catch(function () {});
    });
})();
